import Model from './Model'

export default class AlertsSetting extends Model {
    resource() {
        return 'alertsetting'
    }

}
